import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-client-matter-info',
    styleUrls: ['./client-matter-info.component.scss'],
    templateUrl: './client-matter-info.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ClientMatterInfoComponent {
  @Input() matterData: any[];
  constructor() {}
}
